import { trackEvent } from "src/utils/api/tracker";
import { ActionHandlerParams } from "..";
import { getPageSetSurvey } from "./util";
import {
  saveSurveyAnswers,
  setUserProperties,
} from "src/utils/redux/slices/userData";
import { getInternalSurveyNamespace } from "src/utils/survey/surveyNamespace";
import { isQualifiedForPersonalizedDosing } from "src/utils/userSegment/features";
import goto from "src/pageDefinitions/goto";
import saveToBraze from "@utils/brazeUploader";
import { getEligibleMedProducts } from "@utils/medEligibility";

export const onCompletePDQuestions = async ({
  store,
  pageSet,
  page,
}: ActionHandlerParams) => {
  trackEvent("PDEligibilityDetermined", {
    isEligible: isQualifiedForPersonalizedDosing(),
  });
  saveToBraze({
    user: {
      eligible_med_products: getEligibleMedProducts(),
    },
  });

  const survey = getPageSetSurvey(pageSet, page);

  const { surveyNameSpace } = survey;
  const { currentAnswers } = store.getState();

  const internalNamespaceName = getInternalSurveyNamespace(surveyNameSpace);
  const surveyAnswers = currentAnswers.questionAnswers[surveyNameSpace];

  await store.dispatch(
    saveSurveyAnswers(surveyAnswers, {
      surveyNameSpace: internalNamespaceName,
      overwrite: false,
    })
  );

  await store.dispatch(
    setUserProperties({
      completedPDQuestions: true,
    })
  );

  // Check if we need to return to refill flow
  const refillFlowState = sessionStorage.getItem("noom_refill_flow_state");

  if (refillFlowState === "pd_questions") {
    // Clear the session storage flags
    sessionStorage.removeItem("noom_refill_flow_state");

    // Navigate back to the refill flow
    goto.telehealthEnrollmentSetup();
  }
};
